import { ENVIRONMENTS, IWebEnvironment } from '@shared/interfaces';

/* eslint-disable @typescript-eslint/no-var-requires */
export const environment: IWebEnvironment = {
  env: ENVIRONMENTS.DEV,
  production: false,
  isDebugMode: true,
  isSentryDebugMode: false,
  VERSION: require('../../../../package.json').version,
  CORE_VERSION: require('../../../../package.json').coreversion,
  API_URL: window.location.origin || 'https://uat.neo.base.aiee.echonlabs.com', // NOTE: New Change is only for Base Neo project
  WEB_URL: window.location.origin || 'https://uat.neo.base.aiee.echonlabs.com', // NOTE: New Change is only for Base Neo project
  WEB_DOMAIN: window.location.hostname || 'uat.neo.base.aiee.echonlabs.com', // NOTE: New Change is only for Base Neo project
  API_DOMAIN: window.location.hostname || 'uat.neo.base.aiee.echonlabs.com', // NOTE: New Change is only for Base Neo project
  AI_API_BASE_URL: 'https://uat.ai.neo.base.aiee.echonlabs.com',
  AI_API_KEY: process.env.NX_AI_API_KEY,
  SENTRY_DSN: process.env.NX_WEB_SENTRY_DSN,
};
